const getRandom = arr => arr[Math.floor(Math.random() * arr.length)];
export const getRandomIssueNumber = () => getRandom([0, 1, 2, 3, 5, 8, 13, 20]);

/* eslint-disable max-len */

export const generateEvents = (num) => {
    const titles = ['Database connection', 'Invalid xml', 'Foo bar', 'Database driver not found', 'Environment broken', 'CPU', 'Memory'];
    const descriptions = [
        'Bacon ipsum dolor amet burgdoggen ground round fatback pancetta corned beef, bresaola sausage jerky pork belly strip steak swine pig. Pancetta meatloaf spare ribs porchetta shank. Beef ribs prosciutto chuck landjaeger chicken turkey.',
        'Viral integrate agile intuitive unicorn workflow entrepreneur engaging Steve Jobs ship it bootstrapping minimum viable product. Paradigm intuitive user story viral thought leader grok ship it physical computing driven physical computing engaging human-centered design. Ship it waterfall is so 2000 and late engaging unicorn pair programming cortado integrate SpaceTeam grok waterfall is so 2000 and late.',
        'Convergence prototype big data pitch deck disrupt thought leader SpaceTeam intuitive disrupt big data agile latte thought leader. Agile thinker-maker-doer pitch deck 360 campaign SpaceTeam ideate cortado quantitative vs. qualitative.',
        'Engaging cortado engaging ship it actionable insight agile responsive waterfall is so 2000 and late ideate co-working parallax fund Steve Jobs ideate. User centered design actionable insight 360 campaign user centered design big data waterfall is so 2000 and late fund innovate.'
    ];
    const types = [['fatal', 'error', 'success', 'warning'], ['success', 'warning'], ['success']][getRandom([0, 1, 2])];
    const helpLink = 'http://example.com';
    const all = [];
    for (let i = 0; i < num; i += 1) {
        all.push({
            title: getRandom(titles),
            description: getRandom(descriptions),
            type: getRandom(types),
            helpLink: getRandom([undefined, helpLink])
        });
    }
    return all;
};

export const generateOldEvents = (num) => {
    const pool = [
        {description: 'database', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {
            description: 'license-too-old',
            date: '2016-12-29 16:00:56',
            level: 'fatal',
            old: true,
            additionalMarkup: '<br/><a href="/confluence/ConfirmNewInstallationWithOldLicense!default.jspa">{{system.error.edit.license.or.evaluate}}</a>'
        }, // TODO: Check the link
        {description: 'jdk', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'upgrade', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'export', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'import', date: '2016-12-29 16:00:56', level: 'fatal', old: true, progress: 60},
        {description: 'setup', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'project-import', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {
            description: 'subscription-expired',
            date: '2016-12-29 16:00:56',
            level: 'fatal',
            old: true,
            additionalMarkup: '<br/><a href="/confluence/ConfirmNewInstallationWithOldLicense!default.jspa">{{system.error.edit.license}}</a>'
        }, // TODO: Check the link
        {description: 'restart', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'reindex', date: '2016-12-29 16:00:56', level: 'fatal', old: true, progress: 60},
        {description: 'license-invalid', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'locale-build-mismatch', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'index-lock-already-exists', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'outdated-plugins-installed', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {description: 'startup-unexpected', date: '2016-12-29 16:00:56', level: 'fatal', old: true, progress: 60},
        {description: 'clustering', date: '2016-12-29 16:00:56', level: 'fatal', old: true},
        {
            description: 'clustering-unlicensed',
            date: '2016-12-29 16:00:56',
            level: 'fatal',
            old: true,
            additionalMarkup: '<br/><a href="/confluence/ConfirmNewInstallationWithOldLicense!default.jspa">{{system.error.edit.license}}</a>'
        } // TODO: Check the link
    ];

    const all = [];
    for (let i = 0; i < num; i += 1) {
        all.push(getRandom(pool));
    }
    return all;
};



// WEBPACK FOOTER //
// ./src/mocks/mock-data.js